import {
  PCM_SIDEPANEL_GAMES_RECENT_PLAY_GAMES_LOCAL_DATA,
  setRegedit,
  startYYBGame,
  startWxGame,
  startQQGame,
  startADPGame,
  supportQQGame,
} from "@/views/GameBox/utils";
import { cloneDeep } from "lodash";

export default {
  namespaced: true,
  state: {
    gameSearchLayer: false, // 搜索图层显隐
    userInfo: {},
    QQRuntimeAbility: true,
    games: [],
    recommendGames: [],
    activeMenuId: "0", //默认推荐
    recentGames: null,
  },
  mutations: {
    setGameSearchLayer(state, payload) {
      state.gameSearchLayer = payload;
    },
    setUserInfo(state, payload) {
      state.userInfo = payload;
    },
    setQQRuntimeAbility(state, payload) {
      state.QQRuntimeAbility = payload;
    },
    setGames(state, payload) {
      state.games = payload;
    },
    setRecommendGames(state, payload) {
      state.recommendGames = payload;
    },
    setActiveMenuId(state, payload) {
      state.activeMenuId = payload;
    },
    setRecentGames(state, payload) {
      state.recentGames = payload;
    },
    setRecentGamesStore(state, payload) {
      // setRecentGames 会写入注册表，这里只更新 store
      state.recentGames = payload
    }
  },
  actions: {
    setUserInfo({ commit }, data) {
      commit("setUserInfo", data);
    },
    setQQRuntimeAbility({ commit }) {
      return new Promise((resolve) => {
        supportQQGame()
          .then(() => {
            commit("setQQRuntimeAbility", true);
            return resolve(true);
          })
          .catch(() => {
            commit("setQQRuntimeAbility", false);
            return resolve(false);
          });
      });
    },
    setRecentGames({ state, commit, rootState }, data) {
      const _data = cloneDeep(data)
      delete _data.unStart // 推荐游戏中已启动游戏，这里仅存储小游戏数据到注册表，不再次启动
      if (state.recentGames) {
        let games = JSON.parse(JSON.stringify(state.recentGames));
        const findIndex = games.findIndex((item) => item.appId === _data.appId);
        if (findIndex > -1) {
          games.splice(findIndex, 1);
          games = [_data, ...games];
        } else {
          games = [_data, ...games];
        }
        commit("setRecentGames", games);
      } else {
        commit("setRecentGames", [_data]);
      }
      // const {
      //   userInfo: { loginid = "" },
      // } = state;
      const loginid = rootState.loginInfo?.loginid || ""
      // 最近在玩分用户存取
      setRegedit(
        PCM_SIDEPANEL_GAMES_RECENT_PLAY_GAMES_LOCAL_DATA + loginid,
        JSON.stringify(state.recentGames)
      );
      if (data.appSource === 'QQ_GAME') {
          // qq 小游戏
          startQQGame(data.appId)
      } else if (data.appSource === 'WX_MINIGAME') {
          // 微信小游戏
          startWxGame(data)
      } else if (data.appSource === 'ADP') {
          // 自研
          startADPGame(data.appId)
      } else if (data.appSource === 'YINGYONGBAO' && !data.unStart) {
          //应用宝
          startYYBGame(data)
      }
    },
  },
};
